const { get, keyBy } = require('lodash');

export const getFirstBlock = (instance) =>
  get(instance, 'block.block[0]');

export const getBlockByName = (instance, name) =>
  get(instance, 'block.block', []).find(({ fieldGroupName }) => fieldGroupName === name);

export const getNamedBlocks = (instance) =>
  keyBy(get(instance, 'block.block', []), 'fieldGroupName');